<template>
    <div class="o-t-map t-map">
        <OTerminalMapController />
        <ASwitchCircle
            v-model="contrast"
            :label="$t('ui.switch-contrast')"
        />
        <OCompass
            :value="compassDegree"
        />
        <MZoomControls />
        <OResetMapView
            v-if="isShowResetMapView"
            @closeResetMapView="isShowResetMapView = false"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import OCompass from '../../organisms/o-compass/o-compass';
import ASwitchCircle from '../../atoms/a-switch-circle/a-switch-circle';
import MZoomControls from '../../molecules/m-zoom-controls/m-zoom-controls';
import OResetMapView from "../../organisms/o-reset-map-view/o-reset-map-view";
import OTerminalMapController from "../../organisms/o-terminal-map-controller/o-terminal-map-controller";

import { 
    UI_ON_CAMERA_UPDATE,
    UI_MAP_CLICKED
} from '../../../shared/components/map-viewer/constants/map-events';

export default {
    name: 'OTMap',
    components: {
        OCompass,
        MZoomControls,
        ASwitchCircle,
        OResetMapView,
        OTerminalMapController
    },
    data() {
        return {
            switcher: false,
            compassDegree: 0,
            contrast: false,
            isShowResetMapView: false
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        ...mapState({
            activeStepIndex: state => state.activeStepIndex
        }),
        compassCorrectionValue() {
            return this.getMapConfigProp('compass_correction', 0);
        },
    },
    watch: {
        '$route'() {
            this.isShowResetMapView = false;
        },
        activeStepIndex(value) {
            this.isShowResetMapView = false;
        },
        contrast(val){
            const themeName = val ? 'terminal-contrast' : 'terminal'
            this.$store.commit('setActiveMapTheme', themeName);
        }
    },
    mounted() {
        this.initEventListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_ON_CAMERA_UPDATE, this.updateOrientation);
            this.$bus.$on(UI_MAP_CLICKED, this.onMapClicked)
        },
        deactivateEventsListeners() {
            this.$bus.$off(UI_ON_CAMERA_UPDATE, this.updateOrientation);
            this.$bus.$off(UI_MAP_CLICKED, this.onMapClicked);
        },
        updateOrientation() {
            if(document.viewApi)
                this.compassDegree = this.compassCorrectionValue +  document.viewApi.camera_controller.current_orientation
        },
        onMapClicked() {
            this.isShowResetMapView = true;
        }
    }
}  
</script>

<style lang="scss">
@import "o-t-map";
</style>